export default __webpack_public_path__ + "static/media/ticket_printer.3c9d0d46.png";